import { Alert, AlertTitle } from '@korint/folio';
import { useQuery } from '@tanstack/react-query';
import {
  customerControllerGetCustomerQueryOptions,
  keyValueFieldsToObject,
  axeceControllerListPossibleDrivequantUsersQueryOptions,
} from 'korint-sdk';
import { AlertCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';

import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';

export function DrivequantInactiveUserBanner() {
  const { t } = useTranslation();
  const { policy } = usePolicyOnDashboard();
  const customerId = policy.customers?.[0];
  // folio renders product banners on both dashboards; only the route tells them apart.
  const isPolicyholderView = useMatch('/policyholder/*') !== null;

  const { data: drivequantId } = useQuery({
    ...customerControllerGetCustomerQueryOptions(customerId!),
    enabled: !!customerId,
    select: data =>
      keyValueFieldsToObject(data.customFields ?? []).driveQuantIdConnect as string | undefined,
  });

  const { data: linkedUser } = useQuery({
    ...axeceControllerListPossibleDrivequantUsersQueryOptions(customerId!, {
      count: 1,
      page: 1,
      externalServiceId: drivequantId,
    }),
    enabled: !!customerId && !!drivequantId,
    select: data => data.data[0],
  });

  if (!drivequantId || linkedUser?.enabled !== false) return null;

  return (
    <Alert className="text-destructive">
      <AlertTitle className="flex items-center gap-4 pt-1">
        <AlertCircleIcon aria-hidden="true" />
        {t(
          isPolicyholderView
            ? 'drivequant.linkedUserInactiveDriver'
            : 'drivequant.linkedUserInactiveBroker',
        )}
      </AlertTitle>
    </Alert>
  );
}
